const MuiIconButton = () => ({
  defaultProps: {
    color: "inherit",
  },
});

export default MuiIconButton;
